import { FC } from "react";
import { DefaultToastContainer, ToastContainerProps } from "react-toast-notifications";
import "./ToastContainer.scss";

const ToastContainer: FC<ToastContainerProps> = ({ className, ...otherProps }) => (
  <DefaultToastContainer className={`crowd-birthday10-toast-container ${className || ""}`} {...otherProps} />
);

export default ToastContainer;
